import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class LocationOverviewHealthDashboardRoute extends Route {
  @service globalOverviewAccess;
  @service router;
  @service integrationTelemetryConfig;

  templateName = 'health-dashboard';
  controllerName = 'health-dashboard';

  titleToken = 'Health Dashboard';

  async beforeModel(transition) {
    const preview = transition.to.queryParams?.preview;
    await this.integrationTelemetryConfig.loadGlobal(preview);
    if (!this.globalOverviewAccess.canVisitGlobalHealthDashboard) {
      return void this.router.transitionTo('unauthorized');
    }
  }

  async setupController(controller, model) {
    super.setupController(controller, model);
    controller.showLocationFilter = true;
    controller.selectedLocations = [];
    controller.selectedInstalls = [];
    controller.selectedEventTypes = [];
    controller.selectedIntegrationTypes = [];
    controller.selectedStatuses = [];
    controller.page = 1;
    controller._hiddenEventTypes = [];
    controller._hiddenInstalls = [];
    await controller.fetchData();
    controller.startAutoRefresh();
  }

  deactivate() {
    this.controller.stopAutoRefresh();
  }
}
